import React from 'react';
import { BarChart3, TrendingUp, ArrowUpRight, ArrowDownRight } from 'lucide-react';
export function AnalyticsTab() {
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-305">
      <div data-id="element-306">
        <h1 className="font-serif text-3xl text-stone-900 mb-2" data-id="element-307">
          Analytics & Intelligence
        </h1>
        <p className="text-stone-500" data-id="element-308">
          Track your direct group revenue and prevented wholesale leakage.
        </p>
      </div>

      {/* Main Chart Area (Mocked visually) */}
      <div className="bg-white border border-stone-200 shadow-sm p-6" data-id="element-309">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-310">
          <div data-id="element-311">
            <h2 className="font-serif text-xl text-stone-900" data-id="element-312">
              Direct Group Revenue
            </h2>
            <p className="text-sm text-stone-500" data-id="element-313">
              Trailing 12 months vs previous year
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-314">
            <div className="flex items-center gap-2" data-id="element-315">
              <div className="w-3 h-3 bg-red-600 rounded-sm" data-id="element-316" />
              <span className="text-sm text-stone-600" data-id="element-317">Current (Direct)</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-318">
              <div className="w-3 h-3 bg-stone-200 rounded-sm" data-id="element-319" />
              <span className="text-sm text-stone-600" data-id="element-320">
                Previous (Wholesale)
              </span>
            </div>
          </div>
        </div>

        {/* CSS Bar Chart Mock */}
        <div className="h-64 flex items-end gap-2 sm:gap-4 mt-8 border-b border-stone-200 pb-4" data-id="element-321">
          {[40, 55, 45, 60, 75, 65, 80, 90, 85, 100, 110, 120].map((val, i) => <div key={i} className="flex-1 flex flex-col justify-end gap-1 group relative" data-id="element-322">
              {/* Tooltip */}
              <div className="opacity-0 group-hover:opacity-100 absolute -top-10 left-1/2 -translate-x-1/2 bg-stone-900 text-white text-xs py-1 px-2 rounded pointer-events-none transition-opacity font-mono z-10 whitespace-nowrap" data-id="element-323">
                ${(val * 10000).toLocaleString()}
              </div>
              <div className="w-full bg-stone-200 rounded-t-sm" style={{
            height: `${val * 0.6}%`
          }} data-id="element-324" />
              <div className="w-full bg-red-600 rounded-t-sm transition-all duration-500 hover:bg-red-500" style={{
            height: `${val}%`
          }} data-id="element-325" />
            </div>)}
        </div>
        <div className="flex justify-between mt-2 text-xs font-mono text-stone-400" data-id="element-326">
          <span data-id="element-327">Jan</span>
          <span data-id="element-328">Feb</span>
          <span data-id="element-329">Mar</span>
          <span data-id="element-330">Apr</span>
          <span data-id="element-331">May</span>
          <span data-id="element-332">Jun</span>
          <span data-id="element-333">Jul</span>
          <span data-id="element-334">Aug</span>
          <span data-id="element-335">Sep</span>
          <span data-id="element-336">Oct</span>
          <span data-id="element-337">Nov</span>
          <span data-id="element-338">Dec</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-339">
        {/* Leakage Prevented */}
        <div className="bg-white border border-stone-200 shadow-sm p-6" data-id="element-340">
          <div className="flex items-center gap-3 mb-6" data-id="element-341">
            <div className="p-2 bg-emerald-100 text-emerald-700 rounded-md" data-id="element-342">
              <TrendingUp className="w-5 h-5" data-id="element-343" />
            </div>
            <h2 className="font-serif text-xl text-stone-900" data-id="element-344">
              Leakage Prevented
            </h2>
          </div>

          <div className="space-y-6" data-id="element-345">
            <div data-id="element-346">
              <div className="flex justify-between items-end mb-2" data-id="element-347">
                <p className="font-mono text-3xl text-stone-900" data-id="element-348">$382,500</p>
                <span className="flex items-center text-xs font-mono text-emerald-600 bg-emerald-50 px-2 py-1 rounded" data-id="element-349">
                  <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-350" />
                  12% vs Q3
                </span>
              </div>
              <p className="text-sm text-stone-500" data-id="element-351">
                Total commission saved YTD by quoting direct.
              </p>
            </div>

            <div className="space-y-3 pt-4 border-t border-stone-100" data-id="element-352">
              <div className="flex justify-between text-sm" data-id="element-353">
                <span className="text-stone-600" data-id="element-354">Moon Palace Cancun</span>
                <span className="font-mono font-medium text-emerald-600" data-id="element-355">
                  $145,200
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-356">
                <span className="text-stone-600" data-id="element-357">The Grand at Moon Palace</span>
                <span className="font-mono font-medium text-emerald-600" data-id="element-358">
                  $112,800
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-359">
                <span className="text-stone-600" data-id="element-360">Le Blanc Spa Resort</span>
                <span className="font-mono font-medium text-emerald-600" data-id="element-361">
                  $84,500
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-362">
                <span className="text-stone-600" data-id="element-363">Other Properties</span>
                <span className="font-mono font-medium text-emerald-600" data-id="element-364">
                  $40,000
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Win Rate Analysis */}
        <div className="bg-white border border-stone-200 shadow-sm p-6" data-id="element-365">
          <div className="flex items-center gap-3 mb-6" data-id="element-366">
            <div className="p-2 bg-blue-100 text-blue-700 rounded-md" data-id="element-367">
              <BarChart3 className="w-5 h-5" data-id="element-368" />
            </div>
            <h2 className="font-serif text-xl text-stone-900" data-id="element-369">
              Win Rate Analysis
            </h2>
          </div>

          <div className="space-y-6" data-id="element-370">
            <div data-id="element-371">
              <div className="flex justify-between items-end mb-2" data-id="element-372">
                <p className="font-mono text-3xl text-stone-900" data-id="element-373">38%</p>
                <span className="flex items-center text-xs font-mono text-emerald-600 bg-emerald-50 px-2 py-1 rounded" data-id="element-374">
                  <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-375" />
                  4.2% vs Q3
                </span>
              </div>
              <p className="text-sm text-stone-500" data-id="element-376">
                Average conversion rate from quote to contracted.
              </p>
            </div>

            <div className="space-y-4 pt-4 border-t border-stone-100" data-id="element-377">
              <div data-id="element-378">
                <div className="flex justify-between text-sm mb-1" data-id="element-379">
                  <span className="text-stone-600" data-id="element-380">
                    Instant Quotes (&lt; 5 mins)
                  </span>
                  <span className="font-mono font-medium text-stone-900" data-id="element-381">
                    45% Win Rate
                  </span>
                </div>
                <div className="w-full bg-stone-100 h-2 rounded-full overflow-hidden" data-id="element-382">
                  <div className="bg-blue-500 h-full rounded-full" style={{
                  width: '45%'
                }} data-id="element-383" />
                </div>
              </div>

              <div data-id="element-384">
                <div className="flex justify-between text-sm mb-1" data-id="element-385">
                  <span className="text-stone-600" data-id="element-386">
                    Delayed Quotes (&gt; 24 hrs)
                  </span>
                  <span className="font-mono font-medium text-stone-900" data-id="element-387">
                    18% Win Rate
                  </span>
                </div>
                <div className="w-full bg-stone-100 h-2 rounded-full overflow-hidden" data-id="element-388">
                  <div className="bg-stone-400 h-full rounded-full" style={{
                  width: '18%'
                }} data-id="element-389" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}